import { styled } from "@mui/styles";
import { Box } from "@mui/material";

const HeaderBox = styled(Box)({
  backgroundColor: "#d5d5d5",
  padding: "5px 10px",
});

export default HeaderBox;
